import { PAYMENT_GATEWAYS_API } from 'modules/profile/payment-gateways/api/payment-gateways-api'
import {
  MercadoPagoCreateIntegrationInterface,
  MercadoPagoPaymentIntegrationInterface,
} from 'modules/profile/payment-gateways/integrations/mercadopago/types'
import httpClient from 'shared/utils/http-client'

export const mercadoPagoConnect = (data: MercadoPagoCreateIntegrationInterface) =>
  httpClient.post<MercadoPagoPaymentIntegrationInterface>(
    `${PAYMENT_GATEWAYS_API}/mercado-pago/connect`,
    data,
  )

export const mercadoPagoDisconnect = () =>
  httpClient.delete(`${PAYMENT_GATEWAYS_API}/mercado-pago/disconnect`)
